import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example, pageable) {
    let params = utils.merge(example, pageable);
    return httpService.get("tkTaskAssign", {params: params});
  },

  delete(id) {
    return httpService.delete("tkTaskAssign/" + id);
  },

  addTaskAssigns(form) {
    return httpService.post("tkTaskAssign/addTaskAssigns", form);
  },

  findCoordinator(taskId, receiverUserDeptRoleId) {
    let params = {taskId: taskId, receiverUserDeptRoleId: receiverUserDeptRoleId}
    return httpService.get("tkTaskAssign/findCoordinator", {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/tkTaskAssignService.js